'use client'

import { FC } from 'react'
import { useAppConfig } from '@/root/shared-hooks/appConfig/useAppConfig'
import { useGetTranslations } from '@/root/shared-hooks'
import { ChargesTableProps } from '@/root/shared-types'

interface ChargesSummaryProps {
  chargesTable: ChargesTableProps
}

export const ChargesSummary: FC<ChargesSummaryProps> = ({ chargesTable }) => {
  const { subtotal, vat, price, tax } = chargesTable
  const { formatMoney } = useAppConfig()
  const { getTranslation } = useGetTranslations()

  return (
    <div className="flex w-full flex-col gap-2.5">
      {/* Dotted divider */}
      <div className="w-full py-1.5">
        <div className="border-neutral-darkest w-full border-t-2 border-dotted" />
      </div>

      {/* Summary rows */}
      <div className="grid w-full grid-cols-[1fr_auto] gap-y-2.5">
        <div>
          {getTranslation('confirmationSubtotalFull')} {tax}%
        </div>
        <div className="text-right">{formatMoney(price)}</div>

        <div>
          {getTranslation('confirmationVAT')} {tax}%
        </div>
        <div className="text-right">{formatMoney(vat)}</div>

        <div>{getTranslation('confirmationTotal')}</div>
        <div className="text-right">{formatMoney(subtotal)}</div>
      </div>
    </div>
  )
}
